import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

type EditablePluginProps = {
  readOnly: boolean;
};

export const EditablePlugin = ({ readOnly }: EditablePluginProps): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(!readOnly);
  }, [editor, readOnly]);

  return null;
};
